import React, { Component, Fragment } from 'react';
import {apiActionCall, storeSetupServerAddress} from "../../../actions";
import {connect} from "react-redux";
import {eventConstants, globalConstants, serverFields} from "../../../constants";
import loginAction from "../../../actions/login.action";
import {buildUrlFormat} from "../../../constants/utils";

class FormSetup extends Component {
    constructor(props) {
        super(props);
    }

    handleSubmit(e) {
        if (e) e.preventDefault();

        let { loginState } = this.props;
        let { loginAction } = this.props;

        loginAction({
            type: globalConstants.API,
            success: eventConstants.SUCCESS_PING,
            fail: eventConstants.FAIL_PING,
            url: buildUrlFormat(loginState.serverAddress) + globalConstants.API_PING
        });
    }

    setValue (field, event) {
        let {loginAction} = this.props;
        loginAction({
            type: eventConstants.STORE,
            val: event.target.value
        });
    }

    detectSuccess(){
        let { componentData } = this.props;
        if(componentData.serverData){
            if(componentData.serverData.request === serverFields.PING &&
                componentData.serverData.status === serverFields.OK &&
                !componentData.stored
            ){
                this.props.storeSetupServerAddress({
                    type: eventConstants.SAVE_TO_LOCAL_STORAGE,
                    subType: globalConstants.API_PING,
                    val: componentData.serverAddress
                });
            }
        }
    }



    render() {

        console.log("---> RENDER --- FormSetup   ");

        let { loginState } = this.props;

        console.log(loginState);


        return (
			<Fragment>
            <div className="smartq-app-login smartq-app-setup">
                <div className="smartq-app-login-content">
                    <div className="form">
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <h1 className="title">Setup</h1>
							<div className="form-block-inputs">
								<div className="form-block">
									<input className="form-input"
										   type="text"
										   placeholder="Server Address"
										   name="server_address"
										   required
										   onChange={this.setValue.bind(this, 'server_address')}
										   />
								</div>
							</div>
                            <div className="form-block form-block-buttons">
                                <button type="submit" className="login" disabled={this.props.disabled}>
                                    <span className="texts">Test</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
			</Fragment>
        );
    }
}

const mapStateToProps = (state) =>({
    loginState: state.loginState
});

const mapDispatchToProps =  {
    apiActionCall,
    storeSetupServerAddress,
    loginAction
};


export default connect(mapStateToProps, mapDispatchToProps)(FormSetup);